import type { PropsWithChildren } from "react";

import { useConfig } from "@jti/app-context/useConfig";

const DEFAULT_LAYOUT = "v1";

export const StoreLocatorLayoutSwitcher = ({ layout, children }: PropsWithChildren<{ layout: "v1" | "v2" }>) => {
  const config = useConfig();
  const storeLocatorLayoutVersion = config.storeLocatorLayoutVersion || DEFAULT_LAYOUT;

  if (layout !== storeLocatorLayoutVersion) {
    return null;
  }

  return <>{children}</>;
};
